import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import addOrUpdateBrandPersonaTool from 'common/src/modules/brandGuidelines/copilot/brandGuidelinesAgent/tools/addOrUpdateBrandPersonaTool';
import getPersonaDetailsTool from 'common/src/modules/brandGuidelines/copilot/brandGuidelinesAgent/tools/getPersonaDetailsTool';
import navigateToBrandGuidelinesTabTool from 'common/src/modules/brandGuidelines/copilot/brandGuidelinesAgent/tools/navigateToBrandGuidelinesTabTool';
import updateBrandGuidelinesTool from 'common/src/modules/brandGuidelines/copilot/brandGuidelinesAgent/tools/updateBrandGuidelinesTool';
import {SkillName} from 'common/src/modules/shared/copilot/skills/skills.enums';
import skill from 'common/src/modules/shared/copilot/utils/creators/skill';
import {CLStore} from 'common/src/redux/store';

function brandGuidelinesSkill(store: CLStore) {
  return skill({
    name: SkillName.BrandGuidelines,
    description:
      'Manages brand guidelines — setup, update guidelines, manage personas, and navigate between tabs',
    whenToUse:
      'Setting up and managing brand guidelines and brand personas for the account. Handles updating brand guidelines content, creating and editing brand personas with detailed persona configurations, and navigating between brand guidelines tabs (brand guidelines, brand assets, brand personas).',
    whenToAvoid: 'Campaign setup, creative template editing, or analytics.',
    instructions:
      'Help the user set up and manage brand guidelines and brand personas. You can update brand guidelines, create and edit brand personas, and navigate between brand guidelines tabs.',
    tools: [
      updateBrandGuidelinesTool(store),
      navigateToBrandGuidelinesTabTool(),
      getPersonaDetailsTool(store),
      addOrUpdateBrandPersonaTool(store),
    ],
    applicableBreadcrumbs: [BreadcrumbName.BrandGuidelinesPage],
  });
}

export default brandGuidelinesSkill;
